import { INavigationMenu } from 'interfaces/navigationMenu.interface'

export type BotulismSlugs = '' | 'feedback'

const BotulismMenu: Array<INavigationMenu<BotulismSlugs>[]> = [
  [
    {
      title: 'Botulism',
      slug: '',
      createdAt: new Date(2025, 8, 9),
    },
  ],
]

export { BotulismMenu }
